import { useSelector } from "react-redux"

export const useAgenceAdresse = () => {
    const currentAgence = useSelector(state => state.agences?.currentAgence)
    // console.log({ currentAgence });
    return { agenceAdresse: currentAgence?.addresse }
}